import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

// Assuming you have icons in your project or a library like react-icons
import {
  BsFileEarmarkText,
  BsBriefcaseFill,
  BsFillPersonFill,
  BsBuilding,
  BsGeoAlt,
  BsCalendarDate,
  BsBoxSeam,
  BsFillBuildingFill,
  BsBank,
} from 'react-icons/bs';

function NewExpenseForm() {
  const { accounts } = useMsal();
  const navigate = useNavigate();

  const [userEmail, setUserEmail] = useState('');
  const [userName, setUserName] = useState('');
  const [generatedExpenseId, setGeneratedExpenseId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [categoryBudgets, setCategoryBudgets] = useState([]);

  const [formData, setFormData] = useState({
    expense_name: '',
    expense_type: '',
    recurring_type: '',
    company_name: '',
    department_id: '',
    region_id: '',
    expense_group: '',
    expense_category: '',
    date: '',
  });

  const departments = ['Admin', 'EXC', 'Accounts', 'HR', 'IT', 'Management', 'Other'];
  const groups = ['Inventory', 'Non-Inventory'];
  // Available groups for the current department
  const availableGroups = groups;
  const regions = ['India', 'UK', 'USA', 'Poland'];
  const company_name = [
    'Acorn Universal Consultancy LLP',
    'Astute Healthcare limited',
    'Beauty Magasin Ltd',
    'The Future Center Storage and Distribution Limited',
    'Jambo Supplies Limited',
    'Virtual Works 360 Limited',
    'Acme Pharma Ltd',
    'London Luxury Product',
    'Activecare Online',
    'Hardlow Lubricants Limited',
    'Safe Storage and Distribution Limited',
    'Jambo BV',
    'Doc Pharm GmbH',
    'Beauty Care Global sp. Zoo',
    'Lifexa BVBA',
    'Beauty Store LLC',
    'Beyondtrend USA LLC',
    'Jambo Wholesale Corporation LLC',
    'Global Brand Storage & Ditribution LLC',
    'AHA Goods Wholeseller LLC',
    'A2Z (Acorn USA)',
    'J & D International Business',
    'Acorn Solution Ltd',
    'Astute Wholesale Limited',
    'GCET Limited',
    'The Future Center Property Management Limited'
  ];

  const categoryOptions = {
    Admin: {
      Inventory: ['Blazer', 'Courier', 'Crane Lift', 'CUG Bill', 'Curtain Blinds All Floors & Electric Rooms', 'Electricity', 'Fuel', 'Gazibo Chairs 12Nos', 'Headphone', 'Housekeeping Materials', 'Indoor Game Equipment', 'Inside Pots & Plants', 'Library', 'Meeting Rooms (Noise Problem Solution)', 'Mobile & CUG', 'Office Expense', 'Printing', 'Stationary', 'Tea & Coffee - Green Tea', 'Tea & Coffee - Tea Powder', 'Travelling Expenses', 'Vending Machine', 'Webcam'],
      'Non-Inventory': ['Annual Maintainance Contract - AC', 'Annual Maintainance Contract - DG', 'Annual Maintainance Contract - Electrical', 'Annual Maintainance Contract - FIRE', 'Annual Maintainance Contract - GYM', 'Annual Maintainance Contract - LIFT', 'Annual Maintainance Contract - PCI', 'Annual Maintainance Contract - RO', 'Annual Maintainance Contract - Transformer', 'Annual Maintainance Contract - UPS', 'Ben Marrie', 'Canteen Service', 'Cctv Installation', 'Centerl Ro + Plumbing Work', 'Dg Meter', 'DG Usage - GST', 'Events - Annual Day', 'Events - Blood Donation', 'Events - Christmas', 'Events - Cricket Tournament', 'Events - Diwali', 'Events - Ganesh Chaturthi', 'Events - Health Talks', 'Events - Holi', 'Events - Independence Day', 'Events - Men\'s Day', 'Events - Navratri', 'Events - Prime Day', 'Events - Republic Day', 'Events - Rising Star', 'Events - Women\'s Day', 'Events - Yoga Day', 'Events', 'Garden Service', 'General Maintanace - DG - Spare parts', 'General Maintanace - Fire + PA', 'General Maintanace - GM UPS', 'General Maintanace - Italian (Civil)', 'General Maintanace - RO & Cooler', 'General Maintanace - Transformer', 'General Maintanace - Water Proofing', 'Global', 'Hospitality', 'Housekeeping', 'Insurance - Building', 'Insurance - Car', 'Insurance - GMC & GPA', 'ISO Certificate', 'Other Expense - Admin - First AID', 'Other Expense - Admin - Legal', 'Property Tax', 'Repair & Maintenance - Civil Work', 'Repair & Maintenance - Colour', 'Repair & Maintenance - Electrical Goods', 'Repair & Maintenance - Furniture', 'Repair & Maintenance - Glass Cleaninig', 'Repair & Maintenance - Others', 'Repair & Maintenance - Plumbing', 'Safetty Tank & Kharkuvo Empty', 'Security Service', 'Subscription']
    },
    EXC: {
      Inventory: ['O365 Licenses - AI', 'PowerBI - Premium', 'PowerBI - Pro'],
      'Non-Inventory': ['Expense Committee']
    },
    Accounts: {
      Inventory: [],
      'Non-Inventory': ['Bank Charges', 'Donation', 'Event - Accounts', 'Interest - Car Loan', 'Interest - Solar', 'Interest - Term Loan', 'Other Expense - Finance', 'Software - CompuTDS', 'Software - Tally', 'Solar']
    },
    HR: {
      Inventory: [],
      'Non-Inventory': ['Payroll expenses - ADECCO', 'Payroll expenses - Other Expense', 'Payroll expenses - PLUXEE', 'Recruitment Expenses - INDEED/LINKEDIN', 'Recruitment Expenses - KPMG', 'Recruitment Expenses - NAUKRI', 'Recruitment Expenses - RECRUITMENT DRIVES', 'Staff welfare Expenses', 'Training & Development']
    },
    IT: {
      Inventory: ['Computer - Desktop', 'Computer - Laptop', 'Hardware/Miscellaneous', 'Keyboard & Mouse', 'O365 Licenses - ENTERPRISE MOBILITY+SECURITY E5', 'O365 Licenses - F1', 'O365 Licenses - Microsoft 365 APP FOR BUSINESS', 'O365 Licenses - MICROSOFT BUSINESS BASIC', 'O365 Licenses - MICROSOFT BUSINESS BASIC WITHOUT TEAMS', 'O365 Licenses - MICROSOFT BUSINESS STANDARD', 'O365 Licenses - MICROSOFT TEAMS ESSENTIAL', 'O365 Licenses - ONLINE ARCHIVE', 'O365 Licenses - SHAREPOINT ADVANCE MANAGEMENT', 'Other Licenses - CISCO MERAKI-AP', 'Other Licenses - CISCO SWITCHES', 'Other Licenses - CISCO WEBX', 'Other Licenses - EPBAX', 'Other Licenses - FIREWALL', 'Other Licenses - Google Subscription', 'Other Licenses - MANAGE ENGINE', 'Other Licenses - MATRIX', 'Other Licenses - PROOFPOINT', 'Other Licenses - SOPHOS WEB FILTERING', 'Other Licenses - Web Hosting (Kre8ive)', 'Power Bi Pro', 'Microsoft 365 Copilot', 'Out of Budget'],
      'Non-Inventory': ['Internet - JIO', 'Internet - UNET', 'IT AMC', 'Microsoft Azure - Microsoft', 'Microsoft Azure - PSR IT/Cloud Sol', 'LINNWORKS', 'ECODEL DATAWAREHOUSE CONNECTOR', 'TASKLET LICENSES', 'Services (HR doc Software)', 'Out of Budget', 'Exchange Online Archiving for Exchange Online', 'OTHERS']
    },
    Management: {
      Inventory: [],
      'Non-Inventory': ['Management - Dhruval Sir', 'Management - Gaumish Sir', 'Management - Umesh Sir']
    },
    Other: {
      Inventory: [],
      'Non-Inventory': ['Other Expense']
    }
  };

  const availableCategories = formData.department_id && formData.expense_group
    ? (categoryOptions[formData.department_id]?.[formData.expense_group] || [])
    : [];

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      setUserEmail(accounts[0].username);
      setUserName(accounts[0].name);
    }
  }, [accounts]);

  useEffect(() => {
    const fetchBudgets = async () => {
      try {
        const res = await api.get('/api/expenses/budgets');
        setCategoryBudgets(res.data);
      } catch (err) {
        console.error('Failed to fetch budgets:', err);
      }
    };
    fetchBudgets();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'department_id' || name === 'expense_group') {
      setFormData(prev => ({
        ...prev,
        [name]: value,
        expense_category: '',
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await api.post('/api/expenses', {
        ...formData,
        creator_user_id: userEmail
      });
      const { expense_id } = response.data;
      if (expense_id) {
        setGeneratedExpenseId(expense_id);
        alert(`Expense created with ID: ${expense_id}`);
        navigate(`/expense-details/${encodeURIComponent(expense_id)}`);
      } else {
        alert('Expense created, but no ID returned.');
      }
    } catch (err) {
      console.error('Error submitting expense:', err);
      alert('Failed to create expense.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const selectedCategory = categoryBudgets.find(
    cat => cat.category_name === formData.expense_category
  );

  return (
    <div className="p-6 w-full" style={{ color: 'var(--text)' }}>
      <div className="w-full space-y-6">
        <div className="mb-2">
          <div className="flex items-center mb-1">
            <BsFileEarmarkText className="text-2xl mr-2" style={{ color: 'var(--accent)' }} />
            <h1 className="text-2xl font-bold" style={{ color: 'var(--heading-color, var(--text))' }}>New Expense</h1>
          </div>
          <p className="text-sm mb-2" style={{ color: 'var(--muted)' }}>
            Create and submit a new expense request
          </p>
          <div className="text-sm" style={{ color: 'var(--muted)' }}>
            Created by: {" "}
            <span className="font-semibold" style={{ color: 'var(--text)' }}>{userName || "John Doe"}</span>
          </div>
        </div>

        <div className="rounded-xl shadow-sm p-6 border" style={{ background: 'var(--panel)', borderColor: 'var(--border)' }}>
          <div className="flex items-center mb-4" style={{ color: 'var(--text)' }}>
            <BsFileEarmarkText className="text-xl mr-2" />
            <h3 className="text-lg font-semibold">Expense Identification</h3>
          </div>
          <label className="block text-sm font-medium mb-1" style={{ color: 'var(--text)' }}>
            Expense ID
          </label>
          <input
            value={generatedExpenseId || "Auto-generated after submission"}
            disabled
            className="w-full py-2 px-3 rounded-md text-sm"
            style={{ background: 'var(--bg)', border: '1px solid var(--border)', color: 'var(--muted)' }}
          />
        </div>

        <div className="rounded-xl shadow-sm p-6 border" style={{ background: 'var(--panel)', borderColor: 'var(--border)' }}>
          <div className="flex items-center mb-4" style={{ color: 'var(--text)' }}>
            <BsFileEarmarkText className="text-xl mr-2" />
            <h3 className="text-lg font-semibold">Expense Details</h3>
          </div>
          <p className="text-sm mb-6" style={{ color: 'var(--muted)' }}>
            Fill in the required information for your expense request
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label
                  htmlFor="expense_name"
                  className="flex items-center text-sm font-medium mb-1"
                  style={{ color: 'var(--text)' }}
                >
                  <BsFileEarmarkText className="mr-2" /> Expense Name{" "}
                  <span className="text-red-500">*</span>
                </label>
                <input
                  id="expense_name"
                  name="expense_name"
                  value={formData.expense_name}
                  onChange={handleChange}
                  required
                  placeholder="Enter expense name"
                  className="w-full py-2 px-3 rounded-md text-sm"
                  style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
                />
              </div>
              <div>
                <label
                  htmlFor="expense_type"
                  className="flex items-center text-sm font-medium mb-1"
                  style={{ color: 'var(--text)' }}
                >
                  <BsBank className="mr-2" /> Expense Type <span className="text-red-500">*</span>
                </label>
                <select
                  id="expense_type"
                  name="expense_type"
                  value={formData.expense_type}
                  onChange={handleChange}
                  required
                  className="w-full py-2 px-3 rounded-md text-sm"
                  style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
                >
                  <option value="" disabled>Select Type</option>
                  <option value="Capex">Capex</option>
                  <option value="Opex">Opex</option>
                </select>
              </div>
              <div>
                <label
                  htmlFor="recurring_type"
                  className="flex items-center text-sm font-medium mb-1"
                  style={{ color: 'var(--text)' }}
                >
                  <BsBoxSeam className="mr-2" /> Expense Option <span className="text-red-500">*</span>
                </label>
                <select
                  id="recurring_type"
                  name="recurring_type"
                  value={formData.recurring_type}
                  onChange={handleChange}
                  required
                  className="w-full py-2 px-3 rounded-md text-sm"
                  style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
                >
                  <option value="" disabled>Select Option</option>
                  <option value="Expense">Standard Expense</option>
                  <option value="Recurring Expense">Recurring Expense</option>
                </select>
                <p className="text-xs mt-1" style={{ color: 'var(--muted)' }}>
                  💡 <strong>Note:</strong> Select "Recurring Expense" for approval only from Dr. Kishor Dholwani, or select "Standard Expense" for multi-level approval.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="company_id"
                  className="flex items-center text-sm font-medium mb-1"
                  style={{ color: 'var(--text)' }}
                >
                  <BsBriefcaseFill className="mr-2" /> Company{" "}
                  <span className="text-red-500">*</span>
                </label>
                <select
                  id="company_id"
                  name="company_name"
                  value={formData.company_name}
                  onChange={handleChange}
                  required
                  className="w-full py-2 px-3 rounded-md text-sm"
                  style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
                >
                  <option value="" disabled>
                    Select Company
                  </option>
                  {company_name.map((dep) => (
                    <option key={dep} value={dep}>
                      {dep}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label
                  htmlFor="date"
                  className="flex items-center text-sm font-medium mb-1"
                  style={{ color: 'var(--text)' }}
                >
                  <BsCalendarDate className="mr-2" /> Date{" "}
                  <span className="text-red-500">*</span>
                </label>
                <input
                  id="date"
                  name="date"
                  type="date"
                  value={formData.date}
                  onChange={handleChange}
                  required
                  className="w-full py-2 px-3 rounded-md text-sm"
                  style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="department_id"
                  className="flex items-center text-sm font-medium mb-1"
                  style={{ color: 'var(--text)' }}
                >
                  <BsBuilding className="mr-2" /> Department{" "}
                  <span className="text-red-500">*</span>
                </label>
                <select
                  id="department_id"
                  name="department_id"
                  value={formData.department_id}
                  onChange={handleChange}
                  required
                  className="w-full py-2 px-3 rounded-md text-sm"
                  style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
                >
                  <option value="" disabled>Select Department</option>
                  {departments.map(dep => (
                    <option key={dep} value={dep}>{dep}</option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="region_id" className="flex items-center text-sm font-medium mb-1" style={{ color: 'var(--text)' }}>
                  <BsGeoAlt className="mr-2" /> Region <span className="text-red-500">*</span>
                </label>
                <select
                  id="region_id"
                  name="region_id"
                  value={formData.region_id}
                  onChange={handleChange}
                  required
                  className="w-full py-2 px-3 rounded-md text-sm"
                  style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
                >
                  <option value="" disabled>Select Region</option>
                  {regions.map(region => (
                    <option key={region} value={region}>{region}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="expense_group" className="flex items-center text-sm font-medium mb-1" style={{ color: 'var(--text)' }}>
                  <BsBoxSeam className="mr-2" /> Expense Group <span className="text-red-500">*</span>
                </label>
                <select
                  id="expense_group"
                  name="expense_group"
                  value={formData.expense_group}
                  onChange={handleChange}
                  required
                  disabled={!formData.department_id}
                  className="w-full py-2 px-3 rounded-md text-sm"
                  style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
                >
                  <option value="" disabled>Select Group</option>
                  {groups.map(group => (
                    <option key={group} value={group}>{group}</option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="expense_category" className="flex items-center text-sm font-medium mb-1" style={{ color: 'var(--text)' }}>
                  <BsFileEarmarkText className="mr-2" /> Expense Category <span className="text-red-500">*</span>
                </label>
                <select
                  id="expense_category"
                  name="expense_category"
                  value={formData.expense_category}
                  onChange={handleChange}
                  required
                  disabled={!formData.expense_group || !formData.department_id}
                  className="w-full py-2 px-3 rounded-md text-sm"
                  style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
                >
                  <option value="" disabled>Select Category</option>
                  {availableCategories.map(cat => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </select>
              </div>
            </div>
            {selectedCategory && (
              <div className="p-4 rounded-md" style={{ background: 'rgba(248,113,113,0.15)', color: '#b91c1c', border: '1px solid rgba(248,113,113,0.35)' }}>
                Remaining budget for <strong>{selectedCategory.category_name}</strong>: ₹
                {selectedCategory.remaining_amount} of ₹{selectedCategory.budget_amount}
              </div>
            )}
            <div className="flex justify-end pt-4">
              <button
                type="submit"
                disabled={isSubmitting}
                className="font-semibold py-2 px-6 rounded-md transition border"
                style={{ background: '#8c211e', color: '#fff', borderColor: '#721a18' }}
              >
                {isSubmitting ? 'Creating...' : 'Create Expense'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default NewExpenseForm;



// import { useMsal } from '@azure/msal-react';
// import { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// function NewExpenseForm() {
//   const { accounts } = useMsal();
//   const navigate = useNavigate();

//   const [userEmail, setUserEmail] = useState('');
//   const [userName, setUserName] = useState('');
//   const [generatedExpenseId, setGeneratedExpenseId] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [categoryBudgets, setCategoryBudgets] = useState([]);

//   const [formData, setFormData] = useState({
//     expense_name: '',
//     department_id: '',
//     region_id: '',
//     expense_group: '',
//     expense_category: '',
//     date: '',
//   });

//   const departments = ['IT', 'HR', 'Admin', 'Others'];
//   const groups = ['Inventory', 'Non-Inventory'];
//   const regions = ['India', 'UK', 'USA', 'Poland'];

//   const categoryOptions = {
//     IT: {
//       Inventory: ['COMPUTER PARTS', 'CABLES', 'MONITORS'],
//       'Non-Inventory': ['SOFTWARE LICENSE', 'IT SUPPORT', 'CLOUD SERVICE'],
//     },
//     Admin: {
//       Inventory: ['HOUSEKEEPING MATERIALS', 'STATIONARY MATERIALS', 'TEA & COFFEE'],
//       'Non-Inventory': ['COURIER', 'CUG BILLS', 'ELECTRICITY','EVENTS','FOOD','FUEL','FURNITURE','GARDEN SERVICE','HOUSEKEEPING','MOBILE & CUG','PAYROLL','PRINTING','SECURITY SERVICE', 'IT', 'WATER','OTHERS','HOSPITALITY -INDIA','HOSPITALITY -GLOBAL','GLOBAL'],
//     },
//     HR: {
//       Inventory: ['GIFT PACKS', 'HR KIT'],
//       'Non-Inventory': ['TRAINING', 'EVENTS'],
//     },
//     Others: {
//       Inventory: ['GENERIC INVENTORY'],
//       'Non-Inventory': ['MISCELLANEOUS'],
//     },
//   };

//   const availableCategories = formData.department_id && formData.expense_group
//     ? (categoryOptions[formData.department_id]?.[formData.expense_group] || [])
//     : [];

//   useEffect(() => {
//     if (accounts && accounts.length > 0) {
//       setUserEmail(accounts[0].username);
//       setUserName(accounts[0].name);
//     }
//   }, [accounts]);

//   useEffect(() => {
//     const fetchBudgets = async () => {
//       try {
//         const res = await axios.get('http://localhost:5000/api/expenses/budgets');
//         setCategoryBudgets(res.data);
//       } catch (err) {
//         console.error('Failed to fetch budgets:', err);
//       }
//     };
//     fetchBudgets();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === 'department_id') {
//       setFormData(prev => ({
//         ...prev,
//         [name]: value,
//         expense_category: '',
//       }));
//     } else if (name === 'expense_group') {
//       setFormData(prev => ({
//         ...prev,
//         [name]: value,
//         expense_category: '',
//       }));
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
//     try {
//       const response = await axios.post('http://localhost:5000/api/expenses', {
//         ...formData,
//         creator_user_id: userEmail
//       });
//       const { expense_id } = response.data;
//       if (expense_id) {
//         setGeneratedExpenseId(expense_id);
//         alert(`Expense created with ID: ${expense_id}`);
//         navigate('/expense-details', { state: { expense_id } });
//       } else {
//         alert('Expense created, but no ID returned.');
//       }
//     } catch (err) {
//       console.error('Error submitting expense:', err);
//       alert('Failed to create expense.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const selectedCategory = categoryBudgets.find(
//     cat => cat.category_name === formData.expense_category
//   );

//   return (
//     <div className="container mt-4">
//       <h3>Submit New Expense</h3>

//       <form onSubmit={handleSubmit}>
//         <div className="mb-3">
//           <label>Expense ID</label>
//           <input className="form-control" value={generatedExpenseId || 'Auto-generated'} disabled />
//         </div>

//         <div className="mb-3">
//           <label>Expense Name</label>
//           <input
//             className="form-control"
//             name="expense_name"
//             value={formData.expense_name}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div className="mb-3">
//           <label>Department</label>
//           <select
//             className="form-control"
//             name="department_id"
//             value={formData.department_id}
//             onChange={handleChange}
//             required
//           >
//             <option value="">Select Department</option>
//             {departments.map(dep => (
//               <option key={dep} value={dep}>{dep}</option>
//             ))}
//           </select>
//         </div>

//         <div className="mb-3">
//           <label>Region</label>
//           <select
//             className="form-control"
//             name="region_id"
//             value={formData.region_id}
//             onChange={handleChange}
//             required
//           >
//             <option value="">Select Region</option>
//             {regions.map(region => (
//               <option key={region} value={region}>{region}</option>
//             ))}
//           </select>
//         </div>

//         <div className="mb-3">
//           <label>Expense Group</label>
//           <select
//             className="form-control"
//             name="expense_group"
//             value={formData.expense_group}
//             onChange={handleChange}
//             required
//             disabled={!formData.department_id}
//           >
//             <option value="">Select Group</option>
//             {groups.map(group => (
//               <option key={group} value={group}>{group}</option>
//             ))}
//           </select>
//         </div>

//         <div className="mb-3">
//           <label>Expense Category</label>
//           <select
//             className="form-control"
//             name="expense_category"
//             value={formData.expense_category}
//             onChange={handleChange}
//             required
//             disabled={!formData.expense_group || !formData.department_id}
//           >
//             <option value="">Select Category</option>
//             {availableCategories.map(cat => (
//               <option key={cat} value={cat}>{cat}</option>
//             ))}
//           </select>
//         </div>

//         {selectedCategory && (
//           <div className="alert alert-info">
//             Remaining budget for <strong>{selectedCategory.category_name}</strong>: ₹
//             {selectedCategory.remaining_amount} of ₹{selectedCategory.budget_amount}
//           </div>
//         )}

//         <div className="mb-3">
//           <label>Date</label>
//           <input
//             className="form-control"
//             name="date"
//             type="date"
//             value={formData.date}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
//           {isSubmitting ? 'Submitting...' : 'Create'}
//         </button>
//       </form>
//     </div>
//   );
// }

// export default NewExpenseForm;

